// extracted by mini-css-extract-plugin
module.exports = {"box":"box-cf889ae771442b886cf75503eed90c29","button-div":"button-div-517be05df0ea9a9daada2d6be1753b20"};